export default {
  MAIN_NAVIGATION: 'main-navigation',
  SUB_NAVIGATION: 'sub-navigation',
  CONTENT: 'main-content',
  FOOTER: 'footer',
};
